<ng-template #header>
  <ac-card-header (back)="back.emit()" (close)="close.emit()" />
</ng-template>

<ac-card>
  <ac-card-content>
    <div class="redemption-dialog">
      <!-- State 1: No Venmo Account -->
      @if (newVenmoAccount()) {
        <app-redemption-dialog-header
          [step]="1"
          [hideBalance]="true"
          [hideSteps]="true"
          [headerGap]="16"
          title="Enter your phone number"
          subtitle="Enter the phone number linked to your Venmo account to continue."
          (close)="close.emit()"
          (back)="back.emit()"
        >
          <app-lottie-animation
            class="center-content"
            [width]="164"
            [height]="60"
            [path]="'connect_venmo'"
          />
        </app-redemption-dialog-header>

        <div class="venmo-redemption__phone-input">
          <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
            <mat-label>Phone Number</mat-label>
            <div matPrefix class="venmo-redemption__phone-prefix">
              <ac-icon iconKey="payment:tel_us_flag" />
              <span class="venmo-redemption__phone-prefix-text">+1</span>
            </div>
            <input
              matInput
              type="tel"
              appUsPhoneInput
              [formControl]="phoneNumber"
              placeholder="(123) 456-7890"
              autocomplete="tel"
            />
            @if (phoneNumber.hasError('required') && phoneNumber.touched) {
              <mat-error>Phone number is required</mat-error>
            }
            @if (phoneNumber.hasError('pattern') && phoneNumber.touched) {
              <mat-error>Please enter a valid 10-digit US phone number</mat-error>
            }
          </mat-form-field>
        </div>

        <button
          [disabled]="phoneNumber.invalid"
          [loading]="linkingAccount()"
          (click)="linkVenmoAccount(); $event.preventDefault()"
          class="ac-btn-lg venmo-redemption__connect-button"
          mat-flat-button
        >
          Connect <ac-icon iconKey="payment:venmo_logo" [useWidth]="true" [size]="66"  />
        </button>

        <div class="redemption-dialog__footer">
          <div class="redemption-dialog__footer-text ac-body-sm">
            We’ll never share your phone number — it’s used only to verify your Venmo connection.
          </div>
        </div>
      }
      @else if (pmSyncState() !== 'syncing' && venmoPaymentMethod() && fee() !== null) {
        <app-redemption-dialog-header
          [step]="2"
          title="Confirm Venmo Redemption"
          subtitle="Please review your redemption details."
          (close)="close.emit()"
          (back)="back.emit()"
        />

        @if (dailyLimitExceeded()) {
          <div class="ac-just-ctr ac-flex">
            <div class="redemption-dialog__error-box">
              <ac-icon iconKey="payment:warning" [size]="24" />
              <div class="ac-body-sm">
                You've already hit your redemption limit for today.<br />
                You must wait until {{ nextAvailableDate() }} to redeem again.
              </div>
            </div>
          </div>
        }

        <!-- Payment Method Display -->
        <div class="redemption-dialog__button-list-button" [style.width]="'auto'">
          <div class="redemption-dialog__button-list-button-icon redemption-dialog__button-list-button-venmo-confirm-icon">
            <ac-icon iconKey="payment:venmo_circle" [size]="32" />
          </div>
          <div class="redemption-dialog__button-list-button-contents">
            <div class="ac-title-md">Venmo • {{ venmoPaymentMethod()!.metadata?.alias }}</div>
            <div class="ac-body-sm redemption-dialog__button-list-button-subtitle">
              <span
                class="redemption-dialog__bank-fee-instant-text ac-body-sm"
                [style.margin-right.px]="4"
              >Instant • {{ fee() | currency : 'USD' : 'symbol-narrow' }}</span>
            </div>
          </div>
        </div>

        <!-- Amount Summary Table -->
        <ul class="redemption-dialog__crypto-confirm-table ac-body-md">
          <li>
            <div class="redemption-dialog__crypto-confirm-table-key">Amount</div>
            <div class="redemption-dialog__crypto-confirm-table-value">
              <div>{{ amount() | currency : 'USD' : 'symbol-narrow' }}</div>
            </div>
          </li>
          <li>
            <div class="redemption-dialog__crypto-confirm-table-key">Transfer Fee</div>
            <div class="redemption-dialog__crypto-confirm-table-value">
              <div>{{ fee() | currency : 'USD' : 'symbol-narrow' }}</div>
            </div>
          </li>
          <li>
            <div class="redemption-dialog__crypto-confirm-table-key">Total Redemption</div>
            <div class="redemption-dialog__crypto-confirm-table-value">
              <div>{{ totalRedemptionAmount() | currency : 'USD' : 'symbol-narrow' }}</div>
            </div>
          </li>
        </ul>

        <button
          [disabled]="dailyLimitExceeded() || hasPlaythroughRequirement()"
          [loading]="loading()"
          class="ac-btn-lg"
          (click)="submit(); $event.preventDefault()"
          mat-flat-button
        >
          Redeem {{ totalRedemptionAmount() | currency : 'USD' : 'symbol-narrow' }}
        </button>

        @if (hasPlaythroughRequirement()) {
          <div class="redemption-dialog__footer ac-body-sm text-warning">
            Due to a recent purchase, your Playthrough Requirement has changed.
            Please refresh the page.
          </div>
        }

        <div class="redemption-dialog__footer">
          <div class="redemption-dialog__footer-text ac-body-sm">
            Venmo redemptions have a {{ fee() | currency : 'USD' : 'symbol-narrow' }}
            fee that is deducted from the requested amount and typically take 30
            minutes but may take longer.
          </div>
        </div>
      }
      @else {
        <div class="redemption-dialog">
          <div class="ac-ctr ac-flex" [style.margin]="'auto'">
            <ac-loading type="spinner" [size]="32" />
          </div>
        </div>
      }
    </div>
  </ac-card-content>
</ac-card>
